import {
  hexToRgb,
  fontColor,
  whiteColor,
} from "assets/jss/material-dashboard-react.js";
import brandTheme from "brandTheme/Theme";

const customTabsStyle = {
  cardTitle: {
    float: "left",
    padding: "10px 10px 10px 0px",
    lineHeight: "24px",
  },
  cardTitleRTL: {
    float: "right",
    padding: "10px 0px 10px 10px !important",
  },
  displayNone: {
    display: "none !important",
  },
  tabsRoot: {
    minHeight: "unset !important",
    overflowX: "visible",
    // "& $tabRootButton": {
    //   // fontSize: "0.875rem",
    // },
  },
  container:{
    width:"215px",
    "@media (max-width:1000px)":{
      width:"100%",
    }
  },
  container1:{
    width:"calc(100% - 60px)",
    "@media (max-width:1000px)":{
      width:"100%",
    }
    },
    tabPannel:{
      width:"calc(100% - 60px)",
    "@media (max-width:1000px)":{
      width:"100%",
    }
  },
  nextButton: {
      boxShadow: "inherit",
      color: brandTheme.white,
      margin: "10px 10px 10px 0 ",
      letterSpacing: "1px",
      height: "36px",
      cursor:"pointer",
      padding: "10px 20px 0px 20px",
      borderRadius: "10px",
      backgroundColor: brandTheme.buttonColor,
      "&:hover": {
        backgroundColor: brandTheme.buttonHoverColor,
        boxShadow: "inherit",
      },
      "&:focus": {
        backgroundColor: brandTheme.buttonHoverColor,
        boxShadow: "inherit",
      },
    },
  itemText: {
    fontFamily: brandTheme.font.poppins,
    fontWeight: "bold",
    margin: "0",
    lineHeight: "30px",
    fontSize: "14px",
    color: brandTheme.black,
    "&:hover": {
      fontSize: "18px",
    },
  },
  tabRootButton: {
    minHeight: "unset !important",
    minWidth: "unset !important",
    width: "unset !important",
    height: "unset !important",
    maxWidth: "unset !important",
    maxHeight: "unset !important",
    padding: "10px 15px",
    borderRadius: "3px",
    // lineHeight: "24px",
    textTransform:"capitalize",
    border: "0 !important",
    // color: fontColor + " !important",
    marginLeft: "4px",
    backgroundColor: brandTheme.sideBarColor,
    "&:last-child": {
      marginLeft: "0px",
    },
    "&:hover": {
      backgroundColor: brandTheme.sideBarHoverColor,
    },
  },
  tabSelected: {
    // backgroundColor: "rgba(" + hexToRgb(fontColor) + ", 0.2)",
    // transition: "0.2s background-color 0.1s",
    backgroundColor: brandTheme.sideBarColor,
    "&:hover": {
      backgroundColor: brandTheme.sideBarHoverColor,
    },
    "&:focus,&:visited,&": {
      color: brandTheme.black,
      backgroundColor: brandTheme.sideBarHoverColor,
    },
  },
  tabWrapper: {
    display: "inline-block",
    minHeight: "unset !important",
    minWidth: "unset !important",
    // width: "unset !important",
    height: "unset !important",
    maxWidth: "unset !important",
    maxHeight: "unset !important",
    fontWeight: "500",
    fontSize: "12px",
    marginTop: "1px",
    fontFamily: brandTheme.font.poppins,
    textAlign:"start",
    "& > svg,& > .material-icons": {
      verticalAlign: "middle",
      margin: "-1px 5px 0 0 !important",
    },
    "&:hover": {
      fontSize: "18px",
      backgroundColor: brandTheme.sideBarHoverColor,
    },
  },
  itemIcon: {
    width: "24px",
    height: "24px",
    fontSize: "24px",
    lineHeight: "20px",
    float: "left",
    marginRight: "15px",
    textAlign: "center",
    verticalAlign: "middle",
    color: brandTheme.black,
  },
};

export default customTabsStyle;
